var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"position-relative flex-column justify-center empty"},[_vm._t("body",function(){return [_c('div',{staticClass:"text-center character3_none pt-130 size-px-16 color-gray",domProps:{"innerHTML":_vm.text ? _vm.text : '조회된 내역이 없습니다.'}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }